var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "network-diagram-node",
      attrs: {
        "data-node-endpoint": _vm.nodeEndpoint,
        "data-node-uuid": _vm.nodeUUID
      },
      on: { mouseleave: _vm.closeHoverAndMenu }
    },
    [
      _c(
        "div",
        {
          on: {
            mouseenter: function($event) {
              _vm.hoverActive = true
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "symbol-container" },
            [
              _c(_vm.nodeSymbol, {
                tag: "component",
                style: { width: _vm.symbolSize + "px" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.nodeStructure, function(item) {
            return _vm.nodeData[item.varName] !== null
              ? _c("div", { key: item.label, staticClass: "normal-data" }, [
                  item.label
                    ? _c("label", [_vm._v(_vm._s(item.label) + ": ")])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticStyle: { color: "black", "font-weight": "bold" } },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.nodeData[item.varName]) +
                          "\n      "
                      )
                    ]
                  )
                ])
              : _vm._e()
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.hoverActive && !_vm.zoomIn
        ? _c(
            "div",
            {
              staticClass: "network-diagram-hover-container",
              on: {
                mouseleave: _vm.closeHoverAndMenu,
                contextmenu: function($event) {
                  $event.preventDefault()
                  return _vm.openObjectMenu.apply(null, arguments)
                }
              }
            },
            [_c("MoreIcon", { staticClass: "network-diagram-hover-button" })],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db6c2fb6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db6c2fb6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Network/NetworkDiagram/NetworkDiagramNode.vue
// module id = null
// module chunks = 